import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=33cdfa8e&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=33cdfa8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cdfa8e",
  null
  
)

export default component.exports